import { PartialBlob } from "../types";
import { isBlobArchived, isBlobDeleted } from "./blob-status";

export type BlobSortField =
  "name" | "contentType" | "size" | "createdOn" | "lastModifiedOn" | "status";

export type SortDirection = "asc" | "desc";

const getStatusSortValue = (blob: PartialBlob): string => {
  if (isBlobDeleted(blob)) return "deleted";
  return isBlobArchived(blob) ? "archived" : "available";
};

const getSortValue = (
  blob: PartialBlob,
  field: BlobSortField,
): string | number => {
  switch (field) {
    case "name":
      return blob.name.toLowerCase();
    case "contentType":
      return (blob.blobModifiedInformation?.contentType ?? "").toLowerCase();
    case "size":
      return blob.blobModifiedInformation?.size ?? -1;
    case "createdOn":
      return blob.blobModifiedInformation?.createdOn
        ? new Date(blob.blobModifiedInformation.createdOn).getTime()
        : -1;
    case "lastModifiedOn":
      return blob.blobModifiedInformation?.lastModifiedOn
        ? new Date(blob.blobModifiedInformation.lastModifiedOn).getTime()
        : -1;
    case "status":
      return getStatusSortValue(blob);
    default:
      return "";
  }
};

export const sortBlobs = (
  blobs: PartialBlob[],
  field: BlobSortField,
  direction: SortDirection,
): PartialBlob[] => {
  const sorted = [...blobs].sort((a, b) => {
    const valueA = getSortValue(a, field);
    const valueB = getSortValue(b, field);
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  });

  return direction === "desc" ? sorted.reverse() : sorted;
};
